import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import type { PublicIncident } from '../types.ts';

interface Props {
  incidents: PublicIncident[];
}

const fmtDateTime = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo',
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

const TIPO_LABEL: Record<string, string> = {
  FALHA: 'Falha',
  DEGRADACAO: 'Degradação',
};

export function ActiveIncidents({ incidents }: Props) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-gray-900">
      <h2 className="mb-4 text-sm font-semibold text-gray-900 dark:text-white">
        Incidentes Ativos
      </h2>

      {incidents.length === 0 ? (
        <div className="flex items-center gap-2 text-sm" style={{ color: 'var(--color-status-up)' }}>
          <CheckCircle2 size={16} />
          Todos os sistemas operacionais
        </div>
      ) : (
        <div className="space-y-3">
          {incidents.map((inc, idx) => (
            <div
              key={idx}
              className="flex items-start gap-3 rounded-lg border border-gray-100 p-4 dark:border-gray-800"
            >
              <AlertTriangle
                size={16}
                className="mt-0.5 shrink-0"
                style={{ color: inc.tipo === 'FALHA' ? 'var(--color-status-down)' : 'var(--color-status-degraded)' }}
              />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="font-medium text-gray-900 dark:text-white">{inc.titulo}</p>
                  <span
                    className="rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase text-white"
                    style={{
                      backgroundColor: inc.tipo === 'FALHA' ? 'var(--color-status-down)' : 'var(--color-status-degraded)',
                    }}
                  >
                    {TIPO_LABEL[inc.tipo] ?? inc.tipo}
                  </span>
                </div>
                {inc.descricao && (
                  <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{inc.descricao}</p>
                )}
                <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">
                  Iniciado em {fmtDateTime.format(new Date(inc.iniciadoEm))}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
